import { HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

import { SharedHttpClient } from './shared-http-client';

@Injectable({
  providedIn: 'root',
})
export class SharedHttpService {
  private client = inject(SharedHttpClient);

  public readonly error$: Observable<HttpStatusCode>;

  constructor() {
    this.error$ = this.client.error$;
  }

  async get<T>(url: string, authorize = true, withCredentials = false): Promise<T> {
    return firstValueFrom(this.client.get<T>(url, authorize, withCredentials));
  }

  async postFile<T>(url: string, file: Blob, fileName: string, authorize = true, withCredentials = false): Promise<T> {
    return firstValueFrom(this.client.postFile<T>(url, file, fileName, authorize, withCredentials));
  }

  async post<T>(url: string, data: unknown, authorize = true, withCredentials = false): Promise<T> {
    return firstValueFrom(this.client.post<T>(url, data, authorize, withCredentials));
  }

  async put<T>(url: string, data: unknown, authorize = true, withCredentials = false): Promise<T> {
    return firstValueFrom(this.client.put<T>(url, data, authorize, withCredentials));
  }

  async delete<T>(url: string, authorize = true, withCredentials = false): Promise<T> {
    return firstValueFrom(this.client.delete<T>(url, authorize, withCredentials));
  }
}
